import { keepPreviousData, useQuery, UseQueryResult } from "@tanstack/react-query";
import { AxiosError } from "axios";

import { candidatesQueryKeys } from "./query-keys";
import { CandidatesMetricsResponse } from "./types";

import { instance } from "@/lib/axios/instance";

export type UseCandidatesMetricsParams = {
  clients?: string[];
  integrations?: string[];
  matchIds?: string[];
  candidateIds?: string[];
  publicationIds?: string[];
  search?: string;
  tenantId?: string | null;
  startDate?: string | null;
  endDate?: string | null;
};

export function useCandidatesMetrics(
  params: UseCandidatesMetricsParams,
): UseQueryResult<CandidatesMetricsResponse, AxiosError> {
  return useQuery({
    queryKey: candidatesQueryKeys.metrics(params),
    queryFn: () =>
      instance
        .get<CandidatesMetricsResponse>("/api/v2/Candidates/Metrics/Aggregated", { params })
        .then((res) => res.data),
    refetchOnReconnect: false,
    staleTime: 5 * 60 * 1000,
    placeholderData: keepPreviousData,
  });
}
